<template>
  <div>
    <CCol
      sm="12"
      lg="12"
      style="background-size: cover; color: #fff"
      :style="{ backgroundImage: `url(${backgroundUrl})` }"
    >
      <CRow>
        <CCol sm="12" class="mb-5">
          <div class="justify-content-center">
            <h1 class="mt-5 text-center">Search Your Tutors</h1>
            <h3 class="text-center">Where students meet the best tutors</h3>
          </div>
          <div
            class="card-columns mx-auto d-flex justify-content-center col-12 mt-3"
          >
            <div class="card text-center col-8">
              <CRow class="justify-content-center p-3">
                <CCol sm="3" lg="3">
                  <CInput
                    placeholder="Search Tutor Name....."
                     v-model.lazy="SearchQuery"
                    @change="ApplyFilter()"
                    class="mt-1"
                  />
                </CCol>
                <CCol sm="3" lg="3">
                  <v-select
                    v-model="SelectedSubject"
                    :options="subjects"
                    label="SubjectName"
                    class="mt-1"
                    placeholder="--Please Select--"
                   @input="FilterListSubject()"
                  ></v-select>
                </CCol>
                <CCol sm="3" lg="3">
                  <v-select
                    v-model="SelectedGrade"
                    :options="grades"
                    label="GradeName"
                    class="mt-1"
                    placeholder="--Please Select--"
                     @input="FilterListGrade()"
                  ></v-select>
                </CCol>
                <CCol sm="3" lg="3">
                  <CButton
                    style="background: #1565d8"
                    block
                    color="primary"
                    @click="ApplyFilter()"
                    >Search</CButton
                  >
                </CCol>
              </CRow>
            </div>
          </div>
        </CCol>
      </CRow>
    </CCol>
    <CCol sm="12" lg="12">
      <CContainer>
        <div class="justify-content-center">
          <h1 class="mt-5 text-center">We have Exclusive Tutor</h1>
          <br />
        </div>
        <div style="margin: 0 auto">
          <CCol
            style="margin: 0 auto"
            sm="3"
            lg="3"
            class="col-centered text-center"
          >
            <template v-if="Busy == true">
              <div class="loading mt-5">
                <div class="loading__letter">L</div>
                <div class="loading__letter">o</div>
                <div class="loading__letter">a</div>
                <div class="loading__letter">d</div>
                <div class="loading__letter">i</div>
                <div class="loading__letter">n</div>
                <div class="loading__letter">g</div>
                <div class="loading__letter">.</div>
                <div class="loading__letter">.</div>
                <div class="loading__letter">.</div>
              </div>
            </template></CCol
          >
        </div>

        <CRow class="mt-5">
          <CCol
            sm="4"
            lg="4"
            v-for="(item, index) in FilterList"
            v-bind:key="item.Id"
          >
            <div class="member-item-inner">
              <div class="item-thumbnail" data-aos="zoom-in-up">
                <a :href="'#/Profile' + '?userid=' + item.UserId">
            
                    <img  
                     v-if="item.PicturePath == ''"
                    width="360"
                    height="360"
                    src="../assets/img/default.png">
                  <img v-else
                    width="360"
                    height="360"
                    :src="getPic(index)"
                    class="attachment-thumb_526x526 size-thumb_526x526 wp-post-image"
                    alt=""
                    sizes="(max-width: 360px) 100vw, 360px"
                /></a>
              </div>
              <div class="item-content">
                <h5 class="item-title">
                  <a
                    :href="'#/Profile' + '?userid=' + item.UserId"
                    title="title"
                    class="main-color-1-hover text-uppercase"
                    >{{ item.Name }}</a
                  >
                </h5>
                <CButton
                  color="outline-success"
                  class="text-center m-1"
                  v-for="subs in item.TeachingSubjectList.slice(0, 2)"
                  v-bind:key="subs.Id"
                  >{{ subs.Name }}</CButton
                >
                <br />
                <hr />
                <p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 50ch;" v-for="pro in item.ProfessionalProfileList" v-bind:key="pro.Id">{{ pro.Name }}</p>
                <div class="small text-muted">Grade :<span v-for="gr in item.GradeList.slice(0, 2)" v-bind:key="gr.Id">{{ gr.Name }} ,</span> </div>
              </div>
            </div>
          </CCol>
         


        </CRow>
      </CContainer>
    </CCol>
  </div>
</template>     
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundUrl,
      subjects: [],
      grades: [],
      SelectedSubject: "ALL SUBJECTS",
      SelectedGrade: "ALL GRADES",
      list: [],
      FilterList: [],
      SearchQuery: "",
      Busy: false,

      subjectsOptions: [],
    };
  },
  async mounted() {
    this.GetSubject();
    this.GetGrade();
    this.GetListOfTeacher();
  },
   computed: {
   
    
   
  },
  methods: {
    async GetListOfTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
            this.FilterList = this.list;
            this.getPic(this.FilterList.PicturePath);
          }
        });
    },
    getPic(index) {
      return "https://pickiddo.com/" + this.FilterList[index].PicturePath;
    },
    async GetSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.list, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Name }) =>
          _.some([
            _.includes(!Name || Name.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilterList = result;
      }
    },
     FilterListSubject() {
      console.log("testing")
       this.FilterList = this.list;
      
        if (this.SelectedSubject !== "ALL SUBJECT")
        this.FilterList = _.filter(
          this.FilterList,
          (item) => item.TeachingSubjectList[0].Name === this.SelectedSubject.SubjectName
        );
        console.log("t" + this.SelectedSubject.SubjectName)
    },

     FilterListGrade() {
      console.log("testing")
       this.FilterList = this.list;
      
        if (this.SelectedGrade !== "ALL GRADE")
        this.FilterList = _.filter(
          this.FilterList,
          (item) => item.GradeList[0].Name === this.SelectedGrade.GradeName
        );
    },
   
  },
};
</script>
